import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeoutId: number;
    const cycle = (delay: number) => {
      timeoutId = window.setTimeout(() => {
        setVisible(true);
        timeoutId = window.setTimeout(() => {
          setVisible(false);
          setIndex(prev => (prev + 1) % purchaseNotifications.length);
          cycle(12000);
        }, 6000);
      }, delay);
    };
    cycle(9000);
    return () => window.clearTimeout(timeoutId);
  }, [dismissed]);
  const item = purchaseNotifications[index];
  return <AnimatePresence data-id="element-39" data-mp="1gzp1e6zkq9dq">
      {visible && !dismissed && <motion.div initial={{
      x: -24,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -24,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 z-30 w-[calc(100%-1.5rem)] max-w-[320px] sm:bottom-28 sm:left-5" role="status" aria-live="polite" data-id="element-40" data-mp="1gx2t254uzpug">
          <div className="relative flex items-start gap-3 rounded-2xl border border-navy/10 bg-white p-3.5 pr-8 shadow-[0_12px_30px_-10px_rgba(15,37,71,0.35)]" data-id="element-41" data-mp="1axheqv0gbe6s">
            <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-light" data-id="element-42" data-mp="i8tritw56eql">
              <CheckCircle2Icon className="h-5 w-5 text-brand-dark" aria-hidden="true" data-id="element-43" data-mp="x62l7u8x3ulh" />
            </div>
            <div className="min-w-0" data-id="element-44" data-mp="s4my7wn6je0g">
              <p className="text-[13px] font-bold leading-snug text-navy" data-id="element-45" data-mp="28kg40kotdjun">
                {item.name} ha appena acquistato il Sistema
              </p>
              <p className="mt-0.5 text-[12px] leading-snug text-navy/60" data-id="element-46" data-mp="23kleolkot2bp">
                {item.place} · pochi minuti fa
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Chiudi notifica" className="absolute right-2 top-2 rounded-full p-1 text-navy/40 transition-colors duration-150 ease-out hover:bg-navy/5 hover:text-navy" data-id="element-47" data-mp="2fne8de846oq8">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-48" data-mp="1rybqq6dhcvvq" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}